import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 6V5c.003-1.109.9-2 2.009-2h8.982c1.107 0 2.342.834 2.753 1.862l1.071 3.677c.1.247.404.461.675.461H22c1.112 0 2 .898 2 2.006v4.988A1.993 1.993 0 0 1 22.005 18 3.007 3.007 0 0 1 19 21a3 3 0 0 1-3-3h-6a3 3 0 0 1-3 3c-1.656 0-3-1.343-3.004-3A2.007 2.007 0 0 1 2 15.994v-5.495c0-.175.03-.343.085-.499H7.5a.5.5 0 0 0 0-1H3.75 4a1 1 0 0 0 1-1V7H.5a.5.5 0 0 1 0-1H5zm0 0v1h2.5a.5.5 0 0 0 0-1H5zm14 14a2 2 0 1 0 .001-3.999 2 2 0 0 0 0 3.999zM7 20a2 2 0 1 0 .002-3.999A2 2 0 0 0 7 20zM9.5 6a.5.5 0 1 0 0 1h1a.5.5 0 1 0 0-1h-1zm-6 3a1.5 1.5 0 0 0-1.414 1H1.5a.5.5 0 0 1 0-1h2z"
});

var SvgCarFilled = function SvgCarFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCarFilled;